import {
  Close,
  DocumentWithCheck,
  Letter,
  Letters,
  LetterWithAnalytics,
  LetterWithArrowRight,
  LetterWithUser,
  // Mailbox,
  MapPin,
  OpenLetter,
  SendMessage,
  Users,
  CopyToException,
} from 'components/icons'

import { SidebarItemsForViews } from 'types'
import { SERVICE_PROFILE_PERMISSIONS } from './serviceProfilePermissions'

export const SERVICE_PROFILE_SIDEBAR_ITEMS: SidebarItemsForViews[] = [
  {
    id: 1,
    name: 'Geral',
    subItems: [
      {
        name: 'Informações básicas',
        pageKey: 'UPDATE_SERVICE_FORM',
        Icon: OpenLetter,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ],
      },
    ],
  },
  {
    id: 2,
    name: 'Solicitação',
    subItems: [
      {
        name: 'Informações da solicitação',
        pageKey: 'REQUEST_INFORMATION',
        Icon: Letter,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_CUSTOM_FORM],
      },
      {
        name: 'Formulário de solicitação',
        pageKey: 'SERVICE_REQUEST_CUSTOM_FORM',
        Icon: LetterWithUser,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_CUSTOM_FORM],
      },
      {
        name: 'Formulário de aprovação',
        pageKey: 'SERVICE_APROVE_CUSTOM_FORM',
        Icon: LetterWithAnalytics,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_CUSTOM_FORM],
      },
      {
        name: 'Formulário de rejeição',
        pageKey: 'SERVICE_REJECT_CUSTOM_FORM',
        Icon: Close,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_CUSTOM_FORM],
      },
      {
        name: 'Formulário de transmissão',
        pageKey: 'SERVICE_TRASMISSION_CUSTOM_FORM',
        Icon: SendMessage,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_CUSTOM_FORM],
      },
    ],
  },
  {
    id: 3,
    name: 'Automação',
    subItems: [
      {
        name: 'Informações de automação',
        pageKey: 'AUTOMATION_INFORMATION',
        Icon: LetterWithArrowRight,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_CUSTOM_FORM],
      },
      {
        name: 'Automações',
        pageKey: 'SERVICE_AUTOMATIONS',
        Icon: CopyToException,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_PENDING_FORWARDS],
      },
    ],
  },
  {
    id: 4,
    name: 'Vínculos',
    subItems: [
      {
        name: 'Tipos de atividades',
        pageKey: 'BIND_ACTIVITY_TYPE',
        Icon: DocumentWithCheck,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_ACTIVITIES_TYPES],
      },

      {
        name: 'Locais',
        pageKey: 'BIND_PLACE',
        Icon: MapPin,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_PLACES],
      },
      {
        name: 'Carta de serviços',
        pageKey: 'BIND_SERVICE_LETTER',
        Icon: Letters,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_SERVICE_LETTERS],
      },
      {
        name: 'Públicos-alvo',
        pageKey: 'BIND_TARGET_AUDIENCE',
        Icon: LetterWithUser,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_TARGET_AUDIENCES],
      },
      {
        name: 'Reguladores',
        pageKey: 'BIND_PUBLIC_AGENT',
        Icon: Users,
        permission: [SERVICE_PROFILE_PERMISSIONS.READ_PUBLIC_AGENT],
      },
    ],
  },
]
